<template>
  <!-- 季度选择时间控件 -->
  <div class="quarter-picker">
    <span>
      <mark style="position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,0);z-index:999;" v-show="showSeason" @click.stop="showSeason = false"></mark>
      <el-input :placeholder="placeholder" v-model="showValue" prefix-icon="el-icon-date" style="width:160px;" suffix-icon="el-icon-date" @focus="showSeason = true">

       <!-- <i slot="prefix" class="el-input__icon el-icon-date"></i> -->
        <!-- prefix-icon="icon icon-rili" -->
      </el-input>
      <el-card class="box-card" style="width:322px;padding: 0 3px 20px;margin-top:10px;position:fixed;z-index:9999" v-show="showSeason">
        <div slot="header" class="firstBtn">
          <button type="button" :aria-label="$t('season_picker_qian_yi_nian')" class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left" @click="prev"></button>
          <span role="button" class="el-date-picker__header-label">{{ year }}</span>
          <button type="button" :aria-label="$t('season_picker_hou_yi_nian')" @click="next" class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"></button>
        </div>
        <div class="text container">
          <!-- 如下，绑定class,disabled为禁止选择的时间的设置 -->
          <el-button
            type="text"
            size="medium"
            :class="{ colorDis: (this.year === this.defaultyear && this.maxSeason + 1 <= 1) || this.year > this.defaultyear, colorActive: this.year === this.activeYear && this.season === 1 }"
            :disabled="(this.year === this.defaultyear && this.maxSeason + 1 <= 1) || this.year > this.defaultyear"
            style="width:47%;color: #606266;float:left;"
            @click="selectSeason(0)"
          >
            {{ $t('season_picker_di_yi_ji_du') }}
          </el-button>
          <el-button
            type="text"
            size="medium"
            :class="{ colorDis: (this.year === this.defaultyear && this.maxSeason + 1 <= 2) || this.year > this.defaultyear, colorActive: this.year === this.activeYear && this.season === 2 }"
            :disabled="(this.year === this.defaultyear && this.maxSeason + 1 <= 2) || this.year > this.defaultyear"
            style="float:right;width:47%;color: #606266;"
            @click="selectSeason(1)"
          >
            {{ $t('season_picker_di_er_ji_du') }}
          </el-button>
        </div>
        <div class="item container" style="text-align:center;">
          <el-button
            type="text"
            size="medium"
            :class="{ colorDis: (this.year === this.defaultyear && this.maxSeason + 1 <= 3) || this.year > this.defaultyear, colorActive: this.year === this.activeYear && this.season === 3 }"
            :disabled="(this.year === this.defaultyear && this.maxSeason + 1 <= 3) || this.year > this.defaultyear"
            style="width:47%;color: #606266;float:left;"
            @click="selectSeason(2)"
          >
            {{ $t('season_picker_di_san_ji_du') }}
          </el-button>
          <el-button
            type="text"
            size="medium"
            :class="{ colorDis: (this.year === this.defaultyear && this.maxSeason + 1 <= 4) || this.year > this.defaultyear, colorActive: this.year === this.activeYear && this.season === 4 }"
            :disabled="(this.year === this.defaultyear && this.maxSeason + 1 <= 4) || this.year > this.defaultyear"
            style="float:right;width:47%;color: #606266;"
            @click="selectSeason(3)"
          >
            {{ $t('season_picker_di_si_ji_du') }}
          </el-button>
        </div>
      </el-card>
    </span>
  </div>
</template>
<script>
/**
 * @file:  View 组件 季节选择控件
 * @description: UI组件  可选择季节
 * @api: valueArr : 季度value defalut['01-03', '04-06', '07-09', '10-12'] 默认值待设置
 * 代码中注释部分是组件原默认时间配置，我这里做了更改，但是原设置可以参考
 */

// const i18n = {
//   page_content_select_quarter: '选择季度',
//   page_content_previous_year: '前一年',
//   page_content_year: '年',
//   page_content_next_year: '后一年',
//   page_content_first_season: '第一季度',
//   page_content_second_quarter: '第二季度',
//   page_content_third_quater: '第三季度',
//   page_content_fourth_quarter: '第四季度',
//   page_content_quarter: '季度',

// };
// season_picker_di_yi_ji_du: 第一季度// season_picker_di_er_ji_du: 第二季度// season_picker_di_san_ji_du: 第三季度// season_picker_di_si_ji_du: 第四季度// season_picker_qian_yi_nian: 前一年// season_picker_hou_yi_nian: 后一年// season_picker_ji_du: 季度// season_picker_ji_du_1: 季度

export default {
  name: 'seasonPicker',
  props: {
    valueArr: {
      default: () => ['01', '02', '03', '04'],
      type: Array
    },
    getValue: {
      default: val => val,
      type: Function
    },
    value: {
      type: String,
      default() {
        return '';
      }
    },
    placeholder: {
      type: String,
      default() {
        return this.$t('season_picker_ji_du');
      }
    },
    unbindOrgTime: {
      type: String,
      default() {
        return '';
      }
    }
    // defaultValue: {
    //   // 默认值 201904-201906
    //   default: "",
    //   type: String
    // }
  },
  data() {
    return {
      showSeason: false,
      activeYear: '',
      season: '',
      year: new Date().getFullYear(), // input显示时间，会随着用户操作改变
      defaultyear: new Date().getFullYear(), // 当前年份，不变
      month: new Date().getMonth() + 1, // 当前月份，不变
      maxSeason: '',
      showValue: '',
      beforeyear: null // 默认显示上一季度所用时间，可能是去年
    };
  },
  created() {
  },
  mounted() {
    this.mergeLanguage(null, 'portal_seasonPicker');
  },
  activated() {
  },
  watch: {
    // defaultValue: function(value, oldValue) {
    //   let arr = value.split("-");
    //   this.year = arr[0].slice(0, 4);
    //   let str = arr[0].slice(4, 6) + "-" + arr[1].slice(4, 6);
    //   let arrAll = this.valueArr;
    //   // valueArr ["01-03", "04-06", "07-09", "10-12"]
    //   this.showValue = `${this.year} 年 ${arrAll.indexOf(str) + 1} 季度`;
    // }
    value: function (val) {
      if (val) {
        const activeYear = this.value.split('-')[0];
        this.activeYear = +activeYear;
        const season = this.value.split('-')[1];
        this.season = +season;
        this.updateValue(this.activeYear, this.season);
      } else {
        this.showValue = '';
      }
    },
    unbindOrgTime: {
      immediate: true,
      handler(val) {
        if (val) {
          this.defaultyear = new Date(val).getFullYear(); // 当前年份，不变
          const month = new Date(val).getMonth() + 1; // 当前月份，不变
          setTimeout(() => {
            if (month <= 3) {
              this.maxSeason = 1;
            } else if (month > 3 && month <= 6) {
              this.maxSeason = 2;
            } else if (month > 6 && month <= 9) {
              this.maxSeason = 3;
            } else if (month > 9 && month <= 12) {
              this.maxSeason = 4;
            }
          }, 500);
        }
      },
    },
  },
  methods: {
    one() {
      this.showSeason = false;
    },
    prev() {
      this.year = this.year * 1 - 1;
    },
    next() {
      this.year = this.year * 1 + 1;
    },
    i18nCallback() {
      this.initTime();
    },
    selectSeason(i) {
      const that = this;
      that.season = i + 1;
      this.activeYear = that.year;
      const arr = that.valueArr[i];
      const seasonValue = that.getValue(`${that.year}-${arr}`);
      that.showSeason = false;
      this.updateValue(this.year, this.season);
      // 2020年3季度
      that.$emit('chooseSeason', seasonValue); // 每次选择时间都将当前选择时间发送到父组件
      this.$emit('input', seasonValue);
      // this.$emit('changeTime');
      // console.log(seasonValue);
      this.$emit('change', seasonValue);
    },
    reset() {
      // 季度重置 上一季度
      this.getDefaultTime();
    },
    initTime() {
      var month = this.month;
      if (month <= 3) {
        this.maxSeason = 1;
        this.season = 1;
      } else if (month > 3 && month <= 6) {
        this.maxSeason = 2;
        this.season = 2;
      } else if (month > 6 && month <= 9) {
        this.maxSeason = 3;
        this.season = 3;
      } else if (month > 9 && month <= 12) {
        this.maxSeason = 4;
        this.season = 4;
      }
      if (this.value) {
        const activeYear = this.value.split('-')[0];
        this.activeYear = +activeYear;
        const season = this.value.split('-')[1];
        this.season = +season;
        this.updateValue(this.activeYear, this.season);
        this.year = this.activeYear;
      }
    },
    getDefaultTime() {
      // 获取默认的上一个季度
      var year = this.defaultyear;
      var month = this.month;
      var season = null;
      if (month <= 3) {
        this.maxSeason = 1;
        this.season = 1;
        year -= 1;
        season = 4;
        this.beforeyear = year;
      } else if (month > 3 && month <= 6) {
        this.maxSeason = 2;
        this.season = 2;
        season = 1;
        this.beforeyear = year;
      } else if (month > 6 && month <= 9) {
        this.maxSeason = 3;
        this.season = 3;
        season = 2;
        this.beforeyear = year;
      } else if (month > 9 && month <= 12) {
        this.maxSeason = 4;
        this.season = 4;
        season = 3;
        this.beforeyear = year;
      }
      // this.showValue = `${year} 年 ${season} 季度`;
      this.updateValue(this.year, season);
    },
    updateValue(activeYear, season) {
      const s = this.$t('season_picker_ji_du_1');
      // init显示值
      this.showValue = `${activeYear} ${s} ${season} `;
    },

  }
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.quarter-picker {
  display: inline;
  .firstBtn {
    height: 30px;
    line-height: 34px;
    width: 100%;
    text-align: center;
  }
  .el-input__inner {
    padding: 0 30px 0 32px !important;
    font-size: 14px;
  }
  .text {
    text-align: center;
    margin: 15px 0 10px;
  }
  .item {
    text-align: center;
  }
  .el-input__prefix {
    // left: 0px;
    // line-height: 1;
    .icon-rili {
      line-height: 32px;
      font-size: 14px;
      color: $--color-primary;
    }
  }
  .el-input__inner {
    cursor: pointer;
    height: 40px;
    line-height: 41px;
    // padding-left: 34px;
    font-weight: bold;
    color: $--color-text-primary;
  }
  .el-input__suffix {
    // margin-right: 30px;
    .el-input__icon:before {
      font-family: 'icon' !important;
      content: '\E7F8';
      font-size: 22px;
      color: $--color-warning;
      height: 100%;
    }
  }

  .el-input__prefix {
    color: $--color-primary;
    font-size: 18px;
    margin-right: 8px;
    .icon {
      font-size: 18px;
    }
  }
}
.colorDis {
  color: #999 !important;
}
.colorActive {
  color: $--color-primary !important;
}
.quarter-picker {
  .el-card__header {
    padding: 12px;
  }
}
</style>
